// extracted by mini-css-extract-plugin
export var buttons = "IncrementButton_buttons__eX39Z";
export var lineText = "IncrementButton_lineText__rDw6z";